import { ChangeDetectionStrategy, Component, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'src/app/core/interfaces';
import { GenericEventService } from '../../../../services';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgTemplateOutlet, RouterModule],
  selector: 'app-store-nav-dropdown-links',
  templateUrl: 'store-nav-dropdown-links.component.html',
  styleUrls: ['../store-nav-dropdowns.scss', './store-nav-dropdown-links.component.scss'],
})
export class AppStoreNavDropdownLinksComponent implements OnInit {
  @Input() item!: MenuItem;
  @Input() isVisible!: boolean;

  dropdownOpen = signal(-1);

  visibleItems: WritableSignal<MenuItem[]> = signal([]);

  constructor(private genericEventService: GenericEventService) {}

  ngOnInit(): void {
    if (this.item.childLinks) {
      this.visibleItems.set(this.item.childLinks.filter((child: any) => !child.hidden).slice(0, 4));
    }
  }

  clickItem(): void {
    this.genericEventService.emitMenuClick(false);
  }

  openDropdown(index: number) {
    this.dropdownOpen.set(index);
  }

  toggleDropdown(index: number) {
    this.dropdownOpen.update((i) => (i === index ? -1 : index));
  }

  closeDropdown() {
    this.dropdownOpen.set(-1);
  }
}
